import React, { useState, useEffect } from "react"
import { X } from "lucide-react"
import { useAppCtx, appStore } from "lib/state" 
import { cn } from "lib/utils"



export default function Toast(){

  const { store, AppStore }:any = appStore()
  const { update }:any = AppStore

  const resetToast = () => update("ui.toast", { id: Date.now(), visible: null, type: "info", message: "", waitFor: 5000, showCloseBtn: false, onConfirm: () => null, onDeny: () => null })

  const handleConfirm = () => {
    store.ui.toast.onConfirm() 
    resetToast()
  }

  const handleDeny = () => {
    if( store.ui.toast.onDeny ){
      store.ui.toast.onDeny() 
    }
    resetToast()
  }


  useEffect(() => {
    if (!store.ui.toast?.visible) return;
  
    if (store.ui.toast?.type === "confirm") {
      let countdown: number = store.ui.toast?.waitFor || 5000;
      const timer = setInterval(() => {
        countdown -= 1000;
        if (countdown <= 0) {
          clearInterval(timer);
          handleDeny();
        }
      }, 1000);
      return () => clearInterval(timer);
    } else {
      const timer = setTimeout(() => {
        resetToast();
      }, store.ui.toast.waitFor || 3000);
      return () => clearTimeout(timer);
    }
  }, [store.ui.toast.id]); 

  // useEffect(() => {
  //   console.log(store.ui.toast.message)
  //   if( store.ui.toast.visible === null && store.ui.toast.type && store.ui.toast.message?.length > 0 ){
  //     console.log("making toast")
  //     update("ui.toast", { ...store.ui.toast, id: Date.now(), visible: true })
  //   }
  // },[store.ui.toast.type, store.ui.toast.message])

  if( !store.ui.toast?.visible ) return <></>
  return(
    <div 
      className={cn( 
        "isolate px-10 min-w-[20rem] max-w-[36rem] absolute z-40 flex items-center justify-center py-3 bottom-[10rem] left-0 right-0 mx-auto text-sm px-3 rounded",
        store.ui.toast.type === "info" && "bg-teal-900 text-neutral-100",
        store.ui.toast.type === "warning" && "bg-yellow-900 text-neutral",
        store.ui.toast.type === "error" && "bg-red-500 text-neutral-200",
        store.ui.toast.type === "success" && "bg-green-800 text-neutral-200",
        store.ui.toast.type === "confirm" && "bg-teal-900 text-neutral-200",
      )}
    > 
      <div className="w-full flex justify-between items-center">
        <span>{ store.ui.toast.message }</span>
        { store.ui.toast.type === "confirm" && (
          <div className="flex gap-5">
            <span onClick={handleConfirm} className="px-3 py-[3px] border border-solid border-neutral-300/50 cursor-pointer uppercase">confirm</span>
            <span onClick={handleDeny} className="px-3 py-[3px] border border-solid border-neutral-300/50 cursor-pointer uppercase">deny</span>
          </div>
        )}
        { store.ui.toast.showCloseBtn && <X className="w-4 h-4 stroke-1 cursor-pointer" onClick={resetToast} /> }
      </div>
    </div>
  )

}